export default "__VITE_ASSET__D4uoWJ3H__";